import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { toast } from "react-toastify";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import api from "../../services/api";

import { i18n } from "../../translate/i18n";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import ConfirmationModal from "../../components/ConfirmationModal";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  textRight: {
    textAlign: "right",
  },
  tabPanelsContainer: {
    padding: theme.spacing(2),
  },
}));

const initialSettings = {
  messageInterval: 20,
  longerIntervalAfter: 20,
  greaterInterval: 60,
  variables: [],
};

const CampaignsConfig = () => {
  const classes = useStyles();

  const [settings, setSettings] = useState(initialSettings);
  const [showVariablesForm, setShowVariablesForm] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const [variable, setVariable] = useState({ key: "", value: "" });

  useEffect(() => {
    api.get("/campaign-settings").then(({ data }) => {
      const settingsList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((item) => {
          settingsList.push([item.key, JSON.parse(item.value)]);
        });
        setSettings(Object.fromEntries(settingsList));
      }
    });
  }, []);

  const handleOnChangeVariable = (e) => {
    if (e.target.value !== null) {
      const changedProp = {};
      changedProp[e.target.name] = e.target.value;
      setVariable((prev) => ({ ...prev, ...changedProp }));
    }
  };

  const handleOnChangeSettings = (e) => {
    const changedProp = {};
    changedProp[e.target.name] = e.target.value;
    setSettings((prev) => ({ ...prev, ...changedProp }));
  };

  const addVariable = () => {
    setSettings((prev) => {
      const variablesExists = settings.variables.filter(
        (v) => v.key === variable.key
      );
      const variables = prev.variables;
      if (variablesExists.length === 0) {
        variables.push(Object.assign({}, variable));
        setVariable({ key: "", value: "" });
      }
      return { ...prev, variables };
    });
  };

  const removeVariable = () => {
    const newList = settings.variables.filter((v) => v.key !== selectedKey);
    setSettings((prev) => ({ ...prev, variables: newList }));
    setSelectedKey(null);
  };

  const saveSettings = async () => {
    await api.post("/campaign-settings", { settings });
    toast.success("Configurações salvas");
  };

  const filePath = 'C:\\disparo\\Leads2teste.xlsx';

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

 // const terraSantaText = `Mensagem TERRA SANTA\n\nFicamos felizes por seu interesse no Complexo de chácaras Terra Santa em Trindade, a apenas 35 km de Goiânia! Gostaríamos de convidá-lo para conhecer nossa casa modelo e tudo o que o Terra Santa tem a oferecer. Para tornar sua visita ainda mais especial, preparamos um brinde exclusivo: um ingresso para um dia de lazer no Arca Parque, que é o quintal de casa do MORADOR TERRA SANTA! Agende sua visita e descubra o seu paraíso particular. Esperamos por você!`;
  //const arcaParqueText = `Mensagem ARCA PARQUE\n\nVocê preencheu um formulário nas redes sociais do Arca Parque para conhecer os benefícios exclusivos de se tornar um SÓCIO ARCA PARQUE. Estamos ansiosos para te apresentar todos esses benefícios e proporcionar um dia de lazer incrível após a sua experiência no parque! Para verificarmos a disponibilidade das agendas e garantir que você aproveite tudo isso, basta responder com EU QUERO e finalizamos seu cadastro! Estamos esperando por você para uma experiência inesquecível!`;
  
  // const sendMessageCampaign = async () => {
  //   try {
  //     // Ler a planilha
  //     const workbook = xlsx.readFile(filePath);
  //     const sheetName = workbook.SheetNames[0];
  //     const sheet = workbook.Sheets[sheetName];
  
  //     // Converter para JSON
  //     const records = xlsx.utils.sheet_to_json(sheet);
  
  //     // Processar registros em lotes de 10
  //     for (let i = 0; i < records.length; i += 10) {
  //       const batch = records.slice(i, i + 10);
  
  //       for (const record of batch) {
  //         const {nome, email, status, numeroCorreto } = record;
  //         const textToSend = status.toLowerCase() === 'perdidos' ? `Olá ${nome}, \nFicamos felizes por seu interesse no Complexo de chácaras Terra Santa em Trindade, a apenas 35 km de Goiânia!\n Gostaríamos de convidá-lo para conhecer nossa casa modelo e tudo o que o Terra Santa tem a oferecer.\n Para tornar sua visita ainda mais especial, preparamos um brinde exclusivo: um ingresso para um dia de lazer no Arca Parque, que é o quintal de casa do MORADOR TERRA SANTA! Agende sua visita e descubra o seu paraíso particular. Esperamos por você!` : `Olá ${nome}!, \nVocê preencheu um formulário nas redes sociais do Arca Parque para conhecer os benefícios exclusivos de se tornar um SÓCIO ARCA PARQUE. Estamos ansiosos para te apresentar todos esses benefícios e proporcionar um dia de lazer incrível após a sua experiência no parque! Para verificarmos a disponibilidade das agendas e garantir que você aproveite tudo isso, basta responder com EU QUERO e finalizamos seu cadastro! Estamos esperando por você para uma experiência inesquecível!`;
  
  //         // Fazer chamada à API
  //         try {

  //           const dataUserInfo2 = await api.get("/contacts/verify", {
  //             params: {
  //               name: nome,
  //               number: numeroCorreto,
  //               companyId: localStorage.getItem("companyId")
  //             }
  //           });            
  //           await axios.post(apiEndpoint, {
  //             email,
  //             numero: numeroCorreto,
  //             mensagem: textToSend,
  //           });

  //           const getTicketInfo = await api.get(`/tickets/external/${dataUserInfo2.data.id}`);

  //           await api.put(`/tickets/${getTicketInfo.data.id}`, {
  //             contactId: dataUserInfo2.data.id,
  //             status: "open",
  //             userId: 569,
  //             companyId: localStorage.getItem("companyId"),
  //             queueId: null,
  //             whatsappId: 5,
  //           });

  //           const message = {
  //             read: 1,
  //             fromMe: true,
  //             mediaUrl: "",
  //             body: textToSend,
  //             quotedMsg: null,
  //           };
  //           try {
  //             await api.post(`/messages/${getTicketInfo.data.id}`, message);
  //           } catch (err) {
  //             toastError(err);
  //           }            

  //           console.log(`Mensagem enviada para: ${email}`);
  //         } catch (error) {
  //           console.error(`Erro ao enviar mensagem para ${email}:`, error);
  //         }
  //       }
  
  //       // Pausar após cada lote
  //       console.log('Pausando por 2 minutos...');
  //       await delay(2 * 60 * 1000);
  
  //       // Enviar mensagem para outro endpoint
  //       try {
  //           const messageEu = {
  //             read: 1,
  //             fromMe: true,
  //             mediaUrl: "",
  //             body:  "testando minhas mensagne e ai",
  //             quotedMsg: null,
  //           };
  //           try {
  //             await api.post(`/messages/6482`, messageEu);
  //           } catch (err) {
  //             toastError(err);
  //           }  
  //         console.log('Notificação enviada com sucesso.');
  //       } catch (error) {
  //         console.error('Erro ao enviar notificação:', error);
  //       }
  
  //       // Pausar novamente por 2 minutos antes de processar o próximo lote
  //       console.log('Aguardando mais 2 minutos antes de continuar...');
  //       await delay(2 * 60 * 1000);
  //     }
  
  //     console.log('Processamento concluído!');
  //   } catch (error) {
  //     console.error('Erro ao processar a planilha:', error);
  //   }
  // }

  return (
    <MainContainer>
      <ConfirmationModal
        title={i18n.t("campaigns.confirmationModal.deleteTitle")}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={removeVariable}
      >
        {i18n.t("campaigns.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <MainHeader>
        <Grid style={{ width: "99.6%" }} container>
          <Grid xs={12} item>
            <Title>{i18n.t("campaignsConfig.title")}</Title>
          </Grid>
        </Grid>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <Box className={classes.tabPanelsContainer}>
          <Grid spacing={2} container>
            <Grid xs={12} item>
              <Typography component={"h3"}>Intervalos</Typography>
            </Grid>
            <Grid xs={12} md={4} item>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                fullWidth
              >
                <InputLabel id="messageInterval-label">
                  Intervalo Randômico de Disparo
                </InputLabel>
                <Select
                  name="messageInterval"
                  id="messageInterval"
                  labelId="messageInterval-label"
                  label="Intervalo Randômico de Disparo"
                  value={settings.messageInterval}
                  onChange={(e) => handleOnChangeSettings(e)}
                >
                  <MenuItem value={0}>Sem Intervalo</MenuItem>
                  <MenuItem value={5}>5 segundos</MenuItem>
                  <MenuItem value={10}>10 segundos</MenuItem>
                  <MenuItem value={15}>15 segundos</MenuItem>
                  <MenuItem value={20}>20 segundos</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} md={4} item>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                fullWidth
              >
                <InputLabel id="longerIntervalAfter-label">
                  Intervalo Maior Após
                </InputLabel>
                <Select
                  name="longerIntervalAfter"
                  id="longerIntervalAfter"
                  labelId="longerIntervalAfter-label"
                  label="Intervalo Maior Após"
                  value={settings.longerIntervalAfter}
                  onChange={(e) => handleOnChangeSettings(e)}
                >
                  <MenuItem value={0}>Não definido</MenuItem>
                  <MenuItem value={1}>1 segundo</MenuItem>
                  <MenuItem value={5}>5 segundos</MenuItem>
                  <MenuItem value={10}>10 segundos</MenuItem>
                  <MenuItem value={15}>15 segundos</MenuItem>
                  <MenuItem value={20}>20 segundos</MenuItem>
                  <MenuItem value={30}>30 segundos</MenuItem>
                  <MenuItem value={40}>40 segundos</MenuItem>
                  <MenuItem value={60}>60 segundos</MenuItem>
                  <MenuItem value={80}>80 segundos</MenuItem>
                  <MenuItem value={100}>100 segundos</MenuItem>
                  <MenuItem value={120}>120 segundos</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} md={4} item>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                fullWidth
              >
                <InputLabel id="greaterInterval-label">
                  Intervalo de Disparo Maior
                </InputLabel>
                <Select
                  name="greaterInterval"
                  id="greaterInterval"
                  labelId="greaterInterval-label"
                  label="Intervalo de Disparo Maior"
                  value={settings.greaterInterval}
                  onChange={(e) => handleOnChangeSettings(e)}
                >
                  <MenuItem value={0}>Sem Intervalo</MenuItem>
                  <MenuItem value={1}>1 segundo</MenuItem>
                  <MenuItem value={5}>5 segundos</MenuItem>
                  <MenuItem value={10}>10 segundos</MenuItem>
                  <MenuItem value={15}>15 segundos</MenuItem>
                  <MenuItem value={20}>20 segundos</MenuItem>
                  <MenuItem value={30}>30 segundos</MenuItem>
                  <MenuItem value={40}>40 segundos</MenuItem>
                  <MenuItem value={60}>60 segundos</MenuItem>
                  <MenuItem value={80}>80 segundos</MenuItem>
                  <MenuItem value={100}>100 segundos</MenuItem>
                  <MenuItem value={120}>120 segundos</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} className={classes.textRight} item>
              <Button 
                // onClick={(e) => sendMessageCampaign(e)}
                color="primary"
              >
                Disparar
              </Button>
              <Button
                onClick={() => setShowVariablesForm(!showVariablesForm)}
                color="primary"
                style={{ marginRight: 10 }}
              >
                Adicionar Variável
              </Button>
              <Button
                onClick={saveSettings}
                color="primary"
                variant="contained"
              >
                Salvar Configurações
              </Button>
            </Grid>
            {showVariablesForm && (
              <>
                <Grid xs={12} md={6} item>
                  <TextField
                    label="Atalho"
                    variant="outlined"
                    value={variable.key}
                    name="key"
                    onChange={handleOnChangeVariable}
                    fullWidth
                  />
                </Grid>
                <Grid xs={12} md={6} item>
                  <TextField
                    label="Conteúdo"
                    variant="outlined"
                    value={variable.value}
                    name="value"
                    onChange={handleOnChangeVariable}
                    fullWidth
                  />
                </Grid>
                <Grid xs={12} className={classes.textRight} item>
                  <Button
                    onClick={() => setShowVariablesForm(!showVariablesForm)}
                    color="primary"
                    style={{ marginRight: 10 }}
                  >
                    Fechar
                  </Button>
                  <Button
                    onClick={addVariable}
                    color="primary"
                    variant="contained"
                  >
                    Adicionar
                  </Button>
                </Grid>
              </>
            )}
            {settings.variables.length > 0 && (
              <Grid xs={12} className={classes.textRight} item>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: "1%" }}></TableCell>
                      <TableCell>Atalho</TableCell>
                      <TableCell>Conteúdo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.isArray(settings.variables) &&
                      settings.variables.map((v, k) => (
                        <TableRow key={k}>
                          <TableCell>
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSelectedKey(v.key);
                                setConfirmationOpen(true);
                              }}
                            >
                              <DeleteOutlineIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell>{"{" + v.key + "}"}</TableCell>
                          <TableCell>{v.value}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </Grid>
            )}
          </Grid>
        </Box>
      </Paper>
    </MainContainer>
  );
};

export default CampaignsConfig;
